import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { MsalGuard } from "@azure/msal-angular";
import { AuthRoleGuard } from './services/auth.roleguard.service';

@Injectable({
  providedIn: 'root',
})
export class AppGuard implements CanActivate {

  constructor(
    private msalGuard: MsalGuard,
    private roleGuard: AuthRoleGuard,
  ) {
  }

  public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    for (const guard of this.getOrderedGuards()) {
      if (await guard.canActivate(next, state) === false) {
        return false;
      }
    }
    return true;
  }

  private getOrderedGuards(): CanActivate[] {
    return [
      this.msalGuard,
      this.roleGuard,
    ];
  }
}
